import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Box, Flex } from '@grupoboticario/flora-react'

import { BackofficeImage } from '@/components/BackofficeImage/BackofficeImage'
import { isBrowser } from '@/utils/isBrowser'
import { theme } from '@/utils/themes/theme'

import * as S from './Header.styles'

const Header = ({ openMenu, onToggleSideMenu, ...props }) => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false)

  const toggleSideMenu = (e) => {
    e.preventDefault()
    onToggleSideMenu(!openMenu)
    setIsSideMenuOpen(!isSideMenuOpen)
  }

  return (
    <Box {...props}>
      <Flex css={S.wrapperCss}>
        <Flex align="center" css={S.logoSideCss} justify="flex-start">
          <Box
            alt="Abrir o menu lateral"
            as={BackofficeImage}
            css={S.hamburgerIconCss}
            height={36}
            onClick={(e) => toggleSideMenu(e)}
            src="/img/list.svg"
            width={36}
          />
        </Flex>
        <Flex align="center" css={S.centerSlotCss} justify="center">
          <Link to="/home">
            <Box>
              <BackofficeImage
                alt="Logo da marca"
                height={19}
                priority="true"
                src={`/img/logos/${theme(isBrowser() ? globalThis?.location?.hostname : '')}.svg`}
                width={149}
              />
            </Box>
          </Link>
        </Flex>
        <Box css={S.rightSlotCss} />
      </Flex>
    </Box>
  )
}

export default Header
